<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
			<!-- <Button type="primary" @click="add">新增</Button>
			<Button type="info" @click="cold">冷藏/常温</Button>
			<Button type="success" @click="start">启用/禁用</Button> -->
		</div>
		<div class="query">
			<div class="checkbox">
				<!-- <p style="width: 100px;">查询条件</p>
				<CheckboxGroup v-model="wd">
					<span>温度：</span>
					<Checkbox label="常温"></Checkbox>
					<Checkbox label="冷藏"></Checkbox>
				</CheckboxGroup>
				<CheckboxGroup v-model="zt">
					<span>状态：</span>
					<Checkbox label="启用"></Checkbox>
					<Checkbox label="禁用"></Checkbox>
				</CheckboxGroup>
				<CheckboxGroup v-model="gz">
					<span>是否故障：</span>
					<Checkbox label="正常"></Checkbox>
					<Checkbox label="故障"></Checkbox>
				</CheckboxGroup> -->
			</div>
			<Input search enter-button placeholder="请输入地址/名称查询" style="width: 500px;" v-model="query.like"  @on-search="onsearch"/>
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading" @on-selection-change="selectionChange">
			<template slot-scope="{ row, index }" slot="action">
				<Button size="small" style="margin-right: 5px" @click="aisleList(row.id)" type="primary">货道信息</Button>
				<Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete">停用/启用</Button>
				<Modal v-model="modal2" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>修改状态</span>
					</p>
					<div style="text-align:center">
						<p>确定修改？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading" @click="remove()">确定</Button>
					</div>
				</Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				//查询条件
				wd: [],
				zt: [],
				gz: [],
				loading: false,
				total: 100,
				query: {
					page: '0',
					size: '10',
					id: '' //供应商id
				},
				columns12: [{
						type: 'selection',
						width: 60,
						align: 'center'
					}, {
						title: 'id',
						key: 'id'
					}, {
						title: '编号',
						key: 'macCode'
					},
					{
						title: '名称',
						key: 'macName'
					},
					{
						title: '位置',
						key: 'address'
					},
					{
						title: '状态',
						key: 'startUsing',
						render: (h, params) => {
							if (params.row.startUsing == true) {
								return h("div", "启用")
							} else {
								return h("div", "停用")
							}
						}
					},
					{
						title: '是否故障',
						key: 'state',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "正常")
							} else {
								return h("div", "故障")
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [{
					id: '1',
					machineCode: '',
					macName: 18,
					region: '',
					macTypeName: '饮料机',
					address: '渝北区泰山大道',
					ip: '192.168.10.1',
					startUsing: '启用',
					isRefrigerate: '冷藏',
					state: '正常',
					createdTime: '2010-10-10'
				}],
				deleteId: '',
				modal2: false,
				modal_loading: false,

			}
		},
		methods: {

			onsearch(){
				let _this=this
				_this.query.page=0

				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				})
				_this.ajaxPage()
			},
			selectionChange(selections) { //选中项发生变化时就会触发
				console.log(selections)
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			remove(id) { //删除
			    let _this=this
			    http.http({
			        //这里是你自己的请求方式、url和data参数
			        method: 'post',
			        url: http.url + '/fac/mac/leave/factory',
			        data: {id: _this.deleteId},
					_this: _this,
					success: function(data) {
						_this.modal_loading = false;
						_this.modal2 = false;
						_this.$Message.success('修改成功！！！');
						_this.ajaxPage()
					}
			        //假设后台需要的是表单数据这里你就可以更改
			      })



			},
			aisleList(id) { //设备货道信息
				this.$router.push({
					name: 'jm/platform/oper/mac/aisle/list',
					query: {
						macId: id,
						operId:this.query.id//加盟商id
					}
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/page/jm/oper',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macLeaveFactorys.totalElements
						_this.data6 = data.macLeaveFactorys.content

						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })

			}

		},
		components: {
			page
		},
		created() {
			let operId = this.$route.query.id
			if (operId == undefined || operId == null || operId == "") {

				this.$Message.error('参数错误，请刷新页面!');
				return;
			}
			this.query.id = operId
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}


	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}

	.checkbox {
		display: flex;
		justify-content: flex-end;
	}

	span {
		color: #007AFF;
	}

	.btn {
		margin: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/oper/mac/list.vue